import React from "react"
import useCandidatoReducer from "./candidatoState";
import CandidatoContext from "./candidatoContext";

const CandidatoStateProvider =  ({children})=>{
    return <CandidatoContext.Provider value={useCandidatoReducer()}>{children}</CandidatoContext.Provider>
}

export default CandidatoStateProvider
